import initMemberBookingsNavToggle from '../src/js/member-bookings-nav';
initMemberBookingsNavToggle();
